import React, { useEffect, useState } from 'react';
import classes from "./MyMatches2.module.css";
import { useNavigate } from 'react-router-dom';
import { userMatchesApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import MatchLayoutNew2 from '../../component/NewComponents/MatchLayoutNew2';
import MatchLayoutForPrediction from '../../component/NewComponents/MatchLayoutForPrediction';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { toast } from 'react-toastify';
import Header2 from '../../component/NewComponents/Header2';
import { useTranslation } from 'react-i18next';

const MyMatches2 = () => {
    const navigate = useNavigate();
    const [type, setType] = useState("fantasy");
    const [userMatches, setUserMatches] = useState(null);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);

    const { t } = useTranslation();

    const [loader, setLoader] = useState(true);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    const fetchUserMatches = async (load) => {
        try {
            if (load) setLoading(true);
            setLoader(true);
            const response = await userMatchesApi(userDetails?.token);
            setUserMatches({
                fantasy: response?.data?.fantasy,
                prediction: response?.data?.prediction
            });
            setLoading(false);
            setLoader(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("48"));
                navigate('/');
            } else {
                setLoader(false);
                setLoading(false);
                toast.error(t("20"));
            }
        }
    };

    useEffect(() => { fetchUserMatches(true); }, []);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) fetchUserMatches(false);
            }, 10000);
            return () => clearInterval(intervalId);
        }
    }, [loader]);

    const fantasyList = userMatches?.fantasy ?? [];
    const predictionList = userMatches?.prediction ?? [];
    const activeList = type === "fantasy" ? fantasyList : predictionList;

    return (
        <div className={classes.page}>
            <Header2 active={1} />

            <main className={classes.main}>

                {/* Hero bar */}
                <div className={classes.heroBar}>
                    <div className={classes.heroText}>
                        <span className={classes.heroEyebrow}>{t("117")}</span>
                        <h1 className={classes.heroTitle}>{t("118")} <em>{t("119")}</em></h1>
                    </div>
                </div>

                {/* Type toggle */}
                <div className={classes.tabs_container}>
                    <button
                        type="button"
                        className={`${classes.tab_option} ${type === "fantasy" ? classes.active : ''}`}
                        onClick={() => setType("fantasy")}
                    >
                        ⚽ {t("120")}
                        {fantasyList.length > 0 && type === "fantasy" && (
                            <span style={{ fontSize: 13, fontFamily: 'DM Sans, sans-serif', fontWeight: 600, opacity: 0.75 }}>
                                {fantasyList.length}
                            </span>
                        )}
                    </button>
                    <button
                        type="button"
                        className={`${classes.tab_option} ${type === "predict" ? classes.active : ''}`}
                        onClick={() => setType("predict")}
                    >
                        🎯 {t("121")} &amp; {t("122")}
                        {predictionList.length > 0 && type === "predict" && (
                            <span style={{ fontSize: 13, fontFamily: 'DM Sans, sans-serif', fontWeight: 600, opacity: 0.75 }}>
                                {predictionList.length}
                            </span>
                        )}
                    </button>
                </div>

                {/* Content */}
                {loading ? (
                    <div className={classes.loaderWrap}>
                        <SmallLoader />
                        <p className={classes.loaderText}>{t("123")}</p>
                    </div>
                ) : (
                    <div className={classes.matchGrid}>
                        {activeList.length > 0 ? (
                            activeList.map((match, index) => {
                                const match_details = match?.completed_match_details
                                    ? JSON.parse(match.completed_match_details)
                                    : match?.live_match_details
                                        ? JSON.parse(match.live_match_details)
                                        : null;

                                return type === "fantasy" ? (
                                    <MatchLayoutNew2
                                        match={match}
                                        match_details={match_details}
                                        key={index}
                                        index={index}
                                    />
                                ) : (
                                    <MatchLayoutForPrediction
                                        match={match}
                                        match_details={match_details}
                                        key={index}
                                        index={index}
                                    />
                                );
                            })
                        ) : (
                            <div className={classes.emptyState}>
                                <span className={classes.emptyEmoji}>
                                    {type === "fantasy" ? "⚽" : "🎯"}
                                </span>
                                <p className={classes.emptyTitle}>
                                    {type === "fantasy" ? t("124") : t("125")}
                                </p>
                                <p className={classes.emptySub}>
                                    {type === "fantasy"
                                        ? t("126")
                                        : t("127")}
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </main>
        </div>
    );
};

export default MyMatches2;